module.exports = __webpack_public_path__ + "static/media/pin-intersec-trafficlight.12e45b37.png";